const endpoints = {
	getTreePath: '/file_manager/getTreePath',
	getFolders: '/file_manager/getFolders',
	getFile: '/file_manager/getFile',
	createFolder: '/file_manager/createFolder',
	updateFolder: '/file_manager/updateFolder',
	restoreNodes: '/file_manager/restoreNodes',
	deleteNode: '/file_manager/deleteNodes',
	deleteFolder: '/file_manager/deleteFolder',
	updateNode: '/file_manager/updateNode',
	changeNodesParent: '/file_manager/changeNodesParent'
}
export {endpoints}